// import React, { useState, Fragment } from "react";
// import "../style.scss";

// // ==================== MAIN REUSABLE COMPONENT ====================

// const CoursePage = ({
//   // Basic Info
//   courseTitle = "Advance Java(J2EE)",
//   courseDescription = "To design and develop web-based, network-centric or enterprise applications",
//   breadcrumbText = "Ansys",
  
//   // Images
//   bannerBgClass = "responsive_banner_courses",
//   courseImage = "img/Ansys.jpg",
//   sidebarImage = "img/full-stack.jpg",
//   certificateImage = "img/Certificate.png",
  
//   // Form Configuration
//   formCourseId = "753",
//   formCategory = "16",
//   formButtonText = "Apply Now",
  
//   // Content Sections
//   trainingHighlights = [
//     { img: "https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-training.svg", title: "Instructor Led Training" },
//     { img: "https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-drawer.svg", title: "Weekly Doubt clearing Session" },
//     { img: "https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-assignments.svg", title: "Lifetime Assistance for Revision" },
//     { img: "https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-dashboard.svg", title: "Lifetime Login Access to Student Dashboard" },
//     { img: "https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-certificate.svg", title: "World-Wide Valid Certification" },
//     { img: "https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-report.svg", title: "Study Material, Assignments and Projects" }
//   ],
  
//   courseOverview = {
//     title: "Course Overview",
//     description: "<b>Advanced Java J2EE Course: A Comprehensive Guide to Achieve the Desired Goal</b><br />Java has long been one of the most popular programming languages in the software industry. With its versatility and wide range of applications, Java offers a plethora of opportunities for developers. Among the various branches of Java, Advanced Java J2EE stands out as a powerful tool for building enterprise-level applications. In this article, we will delve into the world of Advanced Java J2EE, explore the significance of courses and training institutes, discuss the certification process, shed light on class options, and provide insights into the associated fees. Whether you are a novice looking to embark on a Java journey or an experienced programmer seeking to upgrade your skills, this article is your go-to resource."
//   },
  
//   courseContents = [
//     { id: 1, title: "Introduction", items: ["Embracing the World of Advanced Java J2EE Internship"] },
//     { id: 2, title: "IT Desk India", items: ["Pioneering the Advanced Java J2EE Internship Institute"] },
//     { id: 3, title: "Advanced Java J2EE Internship Training", items: ["Advancing Your Java Skills"] },
//     { id: 4, title: "The Advanced Java J2EE Internship Class", items: ["A Journey to Java Excellence"] },
//     { id: 5, title: "Advanced Java J2EE Internship Fees", items: ["Investing in Your Java Career"] },
//     { id: 6, title: "Advanced Java J2EE Internship in Jaipur", items: ["Immerse in Java and Jaipur's Charm"] },
//     { id: 7, title: "Advanced Java J2EE Internship Curriculum", items: ["Expanding Java Horizons"] }
//   ],
  
//   certificateSection = {
//     title: "How will you get your certificate?",
//     description1: "Upon successful completion of the program, each intern receives a prestigious Digital Marketing Internship Certificate. This credential not only recognizes their achievements but also enhances their employability.",
//     description2: "CAD DESK Kaniyapuram is a pioneer in Mechanical/Civil training and most of the industries give great recognition to its certificate throughout India and abroad. CAD DESK Kaniyapuram Certificates are ISO verified which makes CAD highly reputed comparing to the other local brands and helps the student get prioritize while going for job opportunities in the industry. CAD DESK Kaniyapuram Software Training is conducted by highly knowledgeable trainers which help students to enhance their skill set by putting great emphasizes on project-based learning."
//   },
  
//   // State options for dropdown
//   stateOptions = [
//     { value: "2", label: "Andhra Pradesh" },
//     { value: "5", label: "Bihar" },
//     { value: "12", label: "Gujarat" },
//     { value: "13", label: "Haryana" },
//     { value: "14", label: "Himachal Pradesh" },
//     { value: "16", label: "Jharkhand" },
//     { value: "17", label: "Karnataka" },
//     { value: "21", label: "Maharashtra" },
//     { value: "28", label: "Punjab" },
//     { value: "29", label: "Rajasthan" },
//     { value: "31", label: "Tamil Nadu" },
//     { value: "32", label: "Telangana" },
//     { value: "35", label: "Uttar Pradesh" }
//   ],
  
//   // Custom styling
//   highlightTitleColor = "#ffc107",
//   marginTop = "-180px",
//   onSubmit = (formData) => console.log("Form submitted:", formData)
// }) => {
  
//   // State for collapsible sections
//   const [showStates, setShowStates] = useState({});
  
//   const toggleList = (listNumber) => {
//     const newShowStates = {};
//     // Close all other sections
//     courseContents.forEach(section => {
//       newShowStates[section.id] = false;
//     });
//     // Toggle the clicked section
//     newShowStates[listNumber] = !showStates[listNumber];
//     setShowStates(newShowStates);
//   };

//   // Handle form submission
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const formData = {
//       name: e.target.fname?.value,
//       email: e.target.email?.value,
//       phone: e.target.phone?.value,
//       state: e.target.states?.value,
//       courseId: formCourseId,
//       category: formCategory
//     };
//     onSubmit(formData);
//   };

//   return (
//     <Fragment>
//       <div id="main-wrapper">
//         <div className="site-wrapper-reveal">
//           {/* Banner with Form */}
//           <BannerWithForm 
//             courseTitle={courseTitle}
//             courseDescription={courseDescription}
//             bannerBgClass={bannerBgClass}
//             formCourseId={formCourseId}
//             formCategory={formCategory}
//             formButtonText={formButtonText}
//             stateOptions={stateOptions}
//             handleSubmit={handleSubmit}
//           />
//         </div>
//       </div>

//       {/* Breadcrumb */}
//       <BreadcrumbNav breadcrumbText={breadcrumbText} />

//       {/* Training Highlights and Overview Section */}
//       <div className="vision-overview" style={{ marginTop: marginTop }}>
//         <div className="container">
//           <div className="section-title-wrap text-center">
//             <br /><br />
//             <h3 className="heading">
//               <span
//                 className="text-color-primary"
//                 style={{ fontSize: "25px", color: highlightTitleColor }}
//               >
//                 {" "}
//                 Training Highlights
//               </span>
//             </h3>
//           </div>
          
//           {/* Training Highlights */}
//           <TrainingHighlights highlights={trainingHighlights} />
//           <br /><br />
          
//           {/* Course Overview */}
//           <CourseOverview 
//             overview={courseOverview}
//             highlightColor={highlightTitleColor}
//           />
//         </div>
//       </div>

//       {/* Course Contents with Image */}
//       <CourseContentsWithImage
//         courseContents={courseContents}
//         showStates={showStates}
//         toggleList={toggleList}
//         courseImage={courseImage}
//         sidebarImage={sidebarImage}
//       />

//       {/* Certificate Section */}
//       <CertificateSection 
//         certificateSection={certificateSection}
//         certificateImage={certificateImage}
//       />

//       <br /><br /><br />
//     </Fragment>
//   );
// };

// // ==================== SUB-COMPONENTS ====================

// const BannerWithForm = ({ 
//   courseTitle, 
//   courseDescription, 
//   bannerBgClass,
//   formCourseId,
//   formCategory,
//   formButtonText,
//   stateOptions,
//   handleSubmit
// }) => (
//   <div className={`about-banner-wrap vision-space bg-img ${bannerBgClass}`}>
//     <div className="container">
//       <div className="row">
//         <div className="col-lg-6 section-space--pt_100">
//           <h1 className="mobile-page-heading">{courseTitle}</h1>
//           <p className="mobile-page-paragraph">{courseDescription}</p>
//         </div>
//         <div className="col-lg-2"></div>
//         <div className="col-lg-4">
//           <div
//             className="form-container mx-auto mx-xl-0 ml-xl-auto border"
//             id="corseform"
//             style={{
//               marginTop: "20px",
//               backgroundColor: "white",
//               alignItems: "center",
//               marginLeft: "100px",
//             }}
//           >
//             <div id="signup-form">
//               <form
//                 id="basic-form"
//                 name="yoursite_wp_mail_from_name"
//                 method="post"
//                 onSubmit={handleSubmit}
//               >
//                 <input type="hidden" name="courseId" value={formCourseId} />
//                 <input type="hidden" name="category" value={formCategory} />
                
//                 {/* Name Field - Fixed Alignment */}
//                 <div className="form-group">
//                   <label htmlFor="fname">Name:</label>
//                   <input
//                     type="text"
//                     id="fname"
//                     name="fname"
//                     className="form-control"
//                     placeholder="Enter Your Name"
//                     required
//                   />
//                 </div>
                
//                 {/* Email Field */}
//                 <div className="form-group">
//                   <label htmlFor="email">Email:</label>
//                   <input
//                     type="email"
//                     id="email"
//                     name="email"
//                     className="form-control"
//                     placeholder="Enter Your Email Address"
//                     required
//                   />
//                 </div>
                
//                 {/* Mobile Field */}
//                 <div className="form-group">
//                   <label htmlFor="phone">Mobile:</label>
//                   <input
//                     type="number"
//                     id="phone"
//                     name="phone"
//                     className="form-control"
//                     placeholder="Enter Your mobile number"
//                     required
//                   />
//                 </div>
                
//                 {/* State Dropdown */}
//                 <div className="form-group mb-0">
//                   <div className="form-row">
//                     <div className="form-group col-6">
//                       <label className="control-label" htmlFor="states">State</label>
//                       <select
//                         id="states"
//                         name="states"
//                         className="form-control"
//                         required
//                       >
//                         <option value="">SELECT STATE</option>
//                         {stateOptions.map(option => (
//                           <option key={option.value} value={option.value}>
//                             {option.label}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                 </div>
                
//                 {/* Submit Button */}
//                 <div
//                   className="form-group mb-0"
//                   style={{ marginLeft: "130px", paddingBottom: "30px" }}
//                 >
//                   <button
//                     type="submit"
//                     id="btn"
//                     className="btn btn-primary contest_register_now"
//                     name="register_users"
//                   >
//                     {formButtonText}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// );
// const BreadcrumbNav = ({ breadcrumbText }) => (
//   <nav aria-label="breadcrumb">
//     <ol className="breadcrumb">
//       <li className="breadcrumb-item">
//         <a href="/">Home</a>
//       </li>
//       <li className="breadcrumb-item active" aria-current="page">
//         {breadcrumbText}
//       </li>
//     </ol>
//   </nav>
// );

// const TrainingHighlightCard = ({ imgSrc, title }) => (
//   <div className="col-12 col-lg-4">
//     <div className="item-container d-flex align-items-center">
//       <div className="image-container">
//         <img src={imgSrc} className="lazy-load" alt={title} />
//       </div>
//       <div className="content-container">
//         <h3 className="title">{title}</h3>
//         <p className="description"></p>
//       </div>
//     </div>
//   </div>
// );

// const TrainingHighlights = ({ highlights }) => (
//   <div className="row">
//     {highlights.map((item, index) => (
//       <TrainingHighlightCard key={index} imgSrc={item.img} title={item.title} />
//     ))}
//   </div>
// );

// const CourseOverview = ({ overview, highlightColor }) => (
//   <div className="row" style={{ marginTop: "-120px" }}>
//     <div className="col-lg-12">
//       <br /><br />
//       <h3 className="heading">
//         <span
//           className="text-color-primary"
//           style={{ fontSize: "30px", color: highlightColor }}
//         >
//           {" "}
//           {overview.title}
//         </span>
//       </h3>
//       <br /><br />
//       <div>
//         <p style={{ marginTop: "-70px", fontSize: "15px", textAlign: 'justify' }}
//            dangerouslySetInnerHTML={{ __html: overview.description }}>
//         </p>
//       </div>
//     </div>
//   </div>
// );

// const CollapsibleSection = ({ isOpen, onToggle, title, items }) => (
//   <div className="responsive_introduction_container">
//     <button
//       className="collapsed responsive_introduction_button"
//       data-toggle="collapse"
//       data-target="#collapse__111"
//       aria-expanded="false"
//       aria-controls="collapse__111"
//       onClick={onToggle}
      
//     >
//       {isOpen ? (
//         <i className="fas fa-arrow-up" style={{color:"white",marginRight:"10px"}}></i>
//       ) : (
//         <i className="fas fa-arrow-down" style={{ color: "white",marginRight:"10px" }}></i>
//       )}
//       {title}
//     </button>
//     {isOpen && (
//       <ul style={{maxWidth:"28rem"}}>
//         {items.map((item, index) => (
//           <li key={index}>{item}</li>
//         ))}
//       </ul>
//     )}
//   </div>
// );

// const CourseContentsWithImage = ({ 
//   courseContents, 
//   showStates, 
//   toggleList, 
//   courseImage, 
//   sidebarImage 
// }) => (
//   <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start" }}>
//     <div style={{ flex: 1 }}>
//       <h3 className="heading_course_content">
//         <span className="text-color-primary responsive_course_content">
//           {" "}
//           Course Contents
//         </span>
//       </h3>
//       <div className="row">
//         <div className="responsive_courese_image_container_mobile_view">
//           <img
//             src={courseImage}
//             alt="Course Image"
//             className="responsive_course_image_mobile_view"
//           />
//         </div>

//         {courseContents.map((section) => (
//           <CollapsibleSection
//             key={section.id}
//             isOpen={showStates[section.id] || false}
//             onToggle={() => toggleList(section.id)}
//             title={section.title}
//             items={section.items}
//           />
//         ))}
//       </div>
//     </div>

//     <div className="responsive_courese_image_container">
//       <img
//         src={sidebarImage}
//         alt="Course Image"
//         className="responsive_course_image"
//       />
//     </div>
//   </div>
// );

// const CertificateSection = ({ certificateSection, certificateImage }) => (
//   <div className="contact-us-section-wrappaer">
//     <div className="container">
//       <div className="row align-items-center">
//         <div className="col-lg-7">
//           <div className="conact-us-wrap-one">
//             <br /><br />
//             <h5 className="heading mb-20">{certificateSection.title}</h5>
//             <div className="center_details">
//               <p>{certificateSection.description1}</p>
//               <p style={{ textAlign: "justify" }}>{certificateSection.description2}</p>
//             </div>
//           </div>
//         </div>
//         <div className="col-lg-5">
//           <div className="contact-form-wrap">
//             <img
//               src={certificateImage}
//               style={{
//                 width: "100%",
//                 marginTop: "100px",
//                 height: "370px",
//               }}
//               alt="Certificate"
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// );

// // ==================== EXPORT ====================

// export default CoursePage;



import React, { useState, Fragment } from "react";
import "../style.scss";
import EnquiryForms from "./Slide.js"; // ← use standalone form, no sliding panel

// ==================== MAIN REUSABLE COMPONENT ====================

const CoursePage = ({
  // Basic Info
  courseTitle = "Advance Java(J2EE)",
  courseDescription = "To design and develop web-based, network-centric or enterprise applications",
  breadcrumbText = "Ansys",
  
  // Images
  bannerBgClass = "responsive_banner_courses",
  courseImage = "img/programming.webp",
  sidebarImage = "img/full-stack.webp",
  certificateImage = "img/Certificate.webp",
  
  // Content Sections
  trainingHighlights = [
    { img: "https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-training.svg", title: "Instructor Led Training" },
    { img: "https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-drawer.svg", title: "Weekly Doubt clearing Session" },
    { img: "https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-assignments.svg", title: "Lifetime Assistance for Revision" },
    { img: "https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-dashboard.svg", title: "Lifetime Login Access to Student Dashboard" },
    { img: "https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-certificate.svg", title: "World-Wide Valid Certification" },
    { img: "https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-report.svg", title: "Study Material, Assignments and Projects" }
  ],
  
  courseOverview = {
    title: "Course Overview",
    description: "<b>Advanced Java J2EE Course: A Comprehensive Guide to Achieve the Desired Goal</b><br />Java has long been one of the most popular programming languages in the software industry. With its versatility and wide range of applications, Java offers a plethora of opportunities for developers. Among the various branches of Java, Advanced Java J2EE stands out as a powerful tool for building enterprise-level applications. In this article, we will delve into the world of Advanced Java J2EE, explore the significance of courses and training institutes, discuss the certification process, shed light on class options, and provide insights into the associated fees. Whether you are a novice looking to embark on a Java journey or an experienced programmer seeking to upgrade your skills, this article is your go-to resource."
  },
  
  courseContents = [
    { id: 1, title: "Introduction", items: ["Embracing the World of Advanced Java J2EE Internship"] },
    { id: 2, title: "IT Desk India", items: ["Pioneering the Advanced Java J2EE Internship Institute"] },
    { id: 3, title: "Advanced Java J2EE Internship Training", items: ["Advancing Your Java Skills"] },
    { id: 4, title: "The Advanced Java J2EE Internship Class", items: ["A Journey to Java Excellence"] },
    { id: 5, title: "Advanced Java J2EE Internship Fees", items: ["Investing in Your Java Career"] },
    { id: 6, title: "Advanced Java J2EE Internship in Jaipur", items: ["Immerse in Java and Jaipur's Charm"] },
    { id: 7, title: "Advanced Java J2EE Internship Curriculum", items: ["Expanding Java Horizons"] }
  ],
  
  certificateSection = {
    title: "How will you get your certificate?",
    description1: "Upon successful completion of the program, each intern receives a prestigious Digital Marketing Internship Certificate. This credential not only recognizes their achievements but also enhances their employability.",
    description2: "CAD DESK Kaniyapuram is a pioneer in Mechanical/Civil training and most of the industries give great recognition to its certificate throughout India and abroad. CAD DESK Kaniyapuram Certificates are ISO verified which makes CAD highly reputed comparing to the other local brands and helps the student get prioritize while going for job opportunities in the industry. CAD DESK Kaniyapuram Software Training is conducted by highly knowledgeable trainers which help students to enhance their skill set by putting great emphasizes on project-based learning."
  },
  
  // Custom styling
  highlightTitleColor = "#ffc107",
  marginTop = "-180px",
}) => {
  
  // State for collapsible sections
  const [showStates, setShowStates] = useState({});
  
  const toggleList = (listNumber) => {
    const newShowStates = {};
    courseContents.forEach(section => {
      newShowStates[section.id] = false;
    });
    newShowStates[listNumber] = !showStates[listNumber];
    setShowStates(newShowStates);
  };

  return (
    <Fragment>
      <div id="main-wrapper">
        <div className="site-wrapper-reveal">
          {/* Banner with EnquiryForm */}
          <BannerWithForm 
            courseTitle={courseTitle}
            courseDescription={courseDescription}
            bannerBgClass={bannerBgClass}
          />
        </div>
      </div>

      {/* Breadcrumb */}
      <BreadcrumbNav breadcrumbText={breadcrumbText} />

      {/* Training Highlights and Overview Section */}
      <div className="vision-overview" style={{ marginTop: marginTop }}>
        <div className="container">
          <div className="section-title-wrap text-center">
            <br /><br />
            <h3 className="heading">
              <span
                className="text-color-primary"
                style={{ fontSize: "25px", color: highlightTitleColor }}
              >
                {" "}
                Training Highlights
              </span>
            </h3>
          </div>
          
          {/* Training Highlights */}
          <TrainingHighlights highlights={trainingHighlights} />
          <br /><br />
          
          {/* Course Overview */}
          <CourseOverview 
            overview={courseOverview}
            highlightColor={highlightTitleColor}
          />
        </div>
      </div>

      {/* Course Contents with Image */}
      <CourseContentsWithImage
        courseContents={courseContents}
        showStates={showStates}
        toggleList={toggleList}
        courseImage={sidebarImage}
        sidebarImage={sidebarImage}
      />

      {/* Certificate Section */}
      <CertificateSection 
        certificateSection={certificateSection}
        certificateImage={certificateImage}
      />

      <br /><br /><br />
    </Fragment>
  );
};

// ==================== SUB-COMPONENTS ====================

// ✅ BannerWithForm now uses EnquiryForm — no hardcoded form, no stateOptions/formCourseId/formCategory props needed
const BannerWithForm = ({ 
  courseTitle, 
  courseDescription, 
  bannerBgClass,
}) => (
  <div className={`about-banner-wrap vision-space bg-img ${bannerBgClass}`}>
    <div className="container">
      <div className="row">
        <div className="col-lg-6 section-space--pt_100">
          <h1 className="mobile-page-heading">{courseTitle}</h1>
          <p className="mobile-page-paragraph">{courseDescription}</p>
        </div>
        <div className="col-lg-2"></div>
        <div className="col-lg-4">
          <div
            className="form-container mx-auto mx-xl-0 ml-xl-auto border"
            id="corseform"
            style={{
              marginTop: "20px",
              backgroundColor: "white",
              alignItems: "center",
              marginLeft: "100px",
            }}
          >
            {/* ✅ EnquiryForm replaces old hardcoded form — no category on course pages */}
                    <EnquiryForms  courseName={courseTitle} showCategory={false} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

const BreadcrumbNav = ({ breadcrumbText }) => (
  <nav aria-label="breadcrumb">
    <ol className="breadcrumb">
      <li className="breadcrumb-item">
        <a href="/">Home</a>
      </li>
      <li className="breadcrumb-item active" aria-current="page">
        {breadcrumbText}
      </li>
    </ol>
  </nav>
);

const TrainingHighlightCard = ({ imgSrc, title }) => (
  <div className="col-12 col-lg-4">
    <div className="item-container d-flex align-items-center">
      <div className="image-container">
        <img src={imgSrc} className="lazy-load" alt={title} />
      </div>
      <div className="content-container">
        <h3 className="title">{title}</h3>
        <p className="description"></p>
      </div>
    </div>
  </div>
);

const TrainingHighlights = ({ highlights }) => (
  <div className="row">
    {highlights.map((item, index) => (
      <TrainingHighlightCard key={index} imgSrc={item.img} title={item.title} />
    ))}
  </div>
);

const CourseOverview = ({ overview, highlightColor }) => (
  <div className="row" style={{ marginTop: "-120px" }}>
    <div className="col-lg-12">
      <br /><br />
      <h3 className="heading">
        <span
          className="text-color-primary"
          style={{ fontSize: "30px", color: highlightColor }}
        >
          {" "}
          {overview.title}
        </span>
      </h3>
      <br /><br />
      <div>
        <p style={{ marginTop: "-70px", fontSize: "15px", textAlign: 'justify' }}
           dangerouslySetInnerHTML={{ __html: overview.description }}>
        </p>
      </div>
    </div>
  </div>
);

const CollapsibleSection = ({ isOpen, onToggle, title, items }) => (
  <div className="responsive_introduction_container">
    <button
      className="collapsed responsive_introduction_button"
      data-toggle="collapse"
      data-target="#collapse__111"
      aria-expanded="false"
      aria-controls="collapse__111"
      onClick={onToggle}
    >
      {isOpen ? (
        <i className="fas fa-arrow-up" style={{ color: "white", marginRight: "10px" }}></i>
      ) : (
        <i className="fas fa-arrow-down" style={{ color: "white", marginRight: "10px" }}></i>
      )}
      {title}
    </button>
    {isOpen && (
      <ul style={{ maxWidth: "28rem" }}>
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    )}
  </div>
);

const CourseContentsWithImage = ({ 
  courseContents, 
  showStates, 
  toggleList, 
  courseImage, 
  sidebarImage 
}) => (
  <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start" }}>
    <div style={{ flex: 1 }}>
      <h3 className="heading_course_content">
        <span className="text-color-primary responsive_course_content">
          {" "}
          Course Contents
        </span>
      </h3>
      <div className="row">
        <div className="responsive_courese_image_container_mobile_view">
          <img
            src={courseImage}
            alt="Course Image"
            className="responsive_course_image_mobile_view"
          />
        </div>

        {courseContents.map((section) => (
          <CollapsibleSection
            key={section.id}
            isOpen={showStates[section.id] || false}
            onToggle={() => toggleList(section.id)}
            title={section.title}
            items={section.items}
          />
        ))}
      </div>
    </div>

    <div className="responsive_courese_image_container">
      <img
        src={sidebarImage}
        alt="Course Image"
        className="responsive_course_image"
      />
    </div>
  </div>
);

const CertificateSection = ({ certificateSection, certificateImage }) => (
  <div className="contact-us-section-wrappaer">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-7">
          <div className="conact-us-wrap-one">
            <br /><br />
            <h5 className="heading mb-20">{certificateSection.title}</h5>
            <div className="center_details">
              <p>{certificateSection.description1}</p>
              <p style={{ textAlign: "justify" }}>{certificateSection.description2}</p>
            </div>
          </div>
        </div>
        <div className="col-lg-5">
          <div className="contact-form-wrap">
            <img
              src={certificateImage}
              style={{
                width: "100%",
                marginTop: "100px",
                height: "370px",
              }}
              alt="Certificate"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

// ==================== EXPORT ====================

export default CoursePage;